// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"3c8535a77039ed5c","5809":"b7352dabb2265bf0"}[chunkId] + ".css";
};